<template>
    <div
        v-show="show"
        ref="container"
        class="mobile-slider"
        :class="{
            'mobile-slider--link': thumbsTheme === 'link',
            'mobile-slider--half-screen': halfScreen
        }"
    >
        <div class="mobile-slider__body">
            <div class="swiper-container mobile-slider__container" ref="slider">
                <div class="swiper-wrapper mobile-slider__wrapper" :style="{ height: maxSlideHeight ? `${maxSlideHeight}px` : null }">
                    <div v-for="(item, index) in data" :key="index" class="swiper-slide mobile-slider__slide" :class="{ 'container': !wideSlide }">
                        <div
                            class="mobile-slider__slide-content"
                            :class="{
                                'mobile-slider__slide-content--wide': wideSlide,
                                'mobile-slider__slide-content--without-thumbs': !item.thumbsTitle && !item.thumbsText.length
                            }"
                            >
                            <z-caption
                                v-if="thumbsTheme !== 'link' && item.title"
                                tag="h3"
                                weight="600"
                                size="2xl"
                            >
                                <span v-html="item.title"></span>
                            </z-caption>

                            <img class="mobile-slider__image" :src="item.image" :alt="item.title">

                            <div v-if="item.thumbsTitle || item.thumbsText.length" class="mobile-slider__slide-thumb">
                                <div class="mobile-slider__slide-thumb-content">
                                    <p v-if="item.thumbsTab" class="mobile-slider__slide-thumb-tab" v-html="item.thumbsTab"></p>

                                    <z-caption
                                        v-if="item.thumbsTitle"
                                        tag="h3"
                                        weight="600"
                                        size="2xl"
                                        class="white-text u-collapse--all"
                                    >
                                        <vue-raw :raw="item.thumbsTitle" />
                                    </z-caption>

                                    <vue-raw v-for="(text, textIndex) in item.thumbsText" :key="textIndex" class="white-text" :raw="text" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile-slider__footer">
                <div class="container u-relative">
                    <div class="mobile-slider__controls">
                        <div class="mobile-slider__fraction">
                            <span class="mobile-slider__fraction-active">
                                {{ getFormattedNumber(activeSlide) }}
                            </span>
                            /
                            <span class="mobile-slider__fraction-count">
                                {{ getFormattedNumber(data.length) }}
                            </span>
                        </div>

                        <button class="mobile-slider__nav-btn mobile-slider__nav-btn--prev" ref="prev">
                            <z-icon
                                name="round-arrow-folder/arrow"
                                dir="left"
                                width="24px"
                                height="24px"
                                class="mobile-slider__nav-icon"
                            />
                        </button>
                        <button class="mobile-slider__nav-btn mobile-slider__nav-btn--next" ref="next">
                            <z-icon
                                name="round-arrow-folder/arrow"
                                dir="right"
                                width="24px"
                                height="24px"
                                class="mobile-slider__nav-icon"
                            />
                        </button>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import { mixinDevice } from '@/utils/mixin'
import { trackGoal } from '@/utils/analytics'
import Swiper from 'swiper/dist/js/swiper.js'

export default {
    name: 'mobile-slider',
    mixins: [mixinDevice],
    props: {
        show: {
            type: Boolean,
            default: false
        },
        wideSlide: {
            type: Boolean,
            default: false
        },
        data: {
            type: Array,
            default: () => []
        },
        halfScreen: {
            type: Boolean
        },
        thumbsTheme: String
    },
    data () {
        return {
            maxSlideHeight: 0,
            sliderId: Math.floor(Math.random() * 10000),
            slider: null,
            activeIndex: 0,
            prevBtn: null,
            nextBtn: null
        }
    },
    computed: {
        activeSlide () {
            return this.activeIndex + 1
        },
        isTrumbsExist () {
            return this.data.some(item => item.thumbsTitle || item.thumbsText.length)
        }
    },
    methods: {
        init () {
            const that = this

            const options = {
                allowTouchMove: true,
                observer: true,
                observeParents: true,
                loop: true,
                navigation: {
                    prevEl: this.prevBtn,
                    nextEl: this.nextBtn
                },
                slidesPerView: 1,
                on: {
                    init () {
                        Array.from(this.slides).forEach((slide, index) => {
                            if (slide.scrollHeight > that.maxSlideHeight) {
                                that.maxSlideHeight = slide.scrollHeight
                            }
                        })
                    },
                    slideChange: () => {
                        that.activeIndex = this.slider.realIndex
                    }
                }
            }

            this.slider = new Swiper(this.$refs.slider, options)
        },
        getFormattedNumber (number) {
            return number < 10 ? `0${number}` : number
        },
        handlerTrackGoal (goalName) {
            trackGoal(goalName)
        }
    },
    watch: {
        show (val) {
            if (this.$refs.container) {
                if (val) {
                    this.$refs.container.parentElement.classList.add('mobile-slider--auto-height')
                } else {
                    this.$refs.container.parentElement.classList.remove('mobile-slider--auto-height')
                }
            }
        }
    },
    mounted () {
        this.prevBtn = this.$refs.prev
        this.nextBtn = this.$refs.next

        setTimeout(() => {
            this.init()
        }, 400)
    }
}
</script>

<style lang="scss">
.mobile-slider {
    $parent: &;
    width: 100%;
    position: relative;

    &--half-screen {
        @include breakpoint(mobile) {
            margin-bottom: $token-spacers-xl;
        }
    }

    &--auto-height {
        min-height: auto !important;
        height: auto !important;
    }

    &--link {
        background: #00366B;
        padding: 16px 0;
    }

    .swiper-container {
        height: 100%;
        display: flex;
        z-index: 1;
    }

    &__slide {
        position: relative;
        overflow: hidden;
    }

    &__image {
        overflow: hidden;
        width: 100%;
        max-width: 100%;
        aspect-ratio: 944 / 333;
        border-radius: 16px;
        object-fit: cover;
        margin-bottom: 8px;

        .mobile-slider__slide-content--without-thumbs & {
            aspect-ratio: 650 / 333;
            border-radius: 0;
        }

        @include breakpoint(v-tablet) {
            aspect-ratio: 536.00 / 326.83;
        }

        @include breakpoint(mobile) {
            aspect-ratio: 338 / 200;
        }
    }

    &__slide-content {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    &__slide-thumb {
        min-height: 96px;
        background: rgba(6, 76, 118, 0.6);
        backdrop-filter: blur(10px);
        border-radius: 16px 16px 16px 0px;
        padding: 20px 16px;
        padding-bottom: 110px;
        flex: 1;

        .mobile-slider--main & {
            background: rgba(6, 76, 118, 0.60);
        }

        @include breakpoint (v-tablet) {
            min-height: auto;
        }

        &-content {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 16px;
        }

        &-tab {
            color: $token-colors-blue-30;
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            margin: 0;
        }
    }

    &__footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        z-index: 2;
    }

    &__controls {
        display: flex;
        align-items: center;
        position: absolute;
        gap: $token-spacers-2-xs;
        bottom: 26px;
        z-index: 3;

        &:not(.mobile-slider__controls--wide) {
            right: 64px;

            @include breakpoint (v-tablet) {
                right: 56px;
            }

            @include breakpoint (mobile) {
                right: 36px;
            }
        }

        &--wide {
            right: 16px;
        }
    }

    &__nav-icon {
        path {
            fill: $token-colors-white;
            transition: fill $transition;
        }
    }

    &__nav-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        background-color: rgba(255, 255, 255, 0.4);
        border: none;
        border-radius: 50%;
        transition: opacity $transition, background-color $transition;

        &:hover {
            background-color: rgba(255, 255, 255, 0.9);

            #{$parent}__nav-icon {
                path {
                    fill: #0077c8;
                }
            }
        }
    }

    &__fraction {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-family: "Roboto Mono";
        font-size: 16px;
        font-weight: 300;
        color: #ffffff;
        margin-right: $token-spacers-3-xs;
    }

    &__fraction-active {
        font-size: 20px;
    }
}
</style>
